var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.getExplorerUrl(this.tx)}},[_c('b-button',{attrs:{"type":"is-text"}},[_vm._v("View Transaction "+_vm._s(_vm.tx))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }